<template>
    <div>
        <v-card>
            <v-toolbar flat dark color="secondary">
                <v-toolbar-title :style="$store.state.textFormatting.headers">
                    Getting started
                </v-toolbar-title>
                <v-spacer />
                <v-flex shrink>
                    <v-btn @click="showCard=!showCard" v-if="showCard" dark fab small color="blue"><h2> - </h2></v-btn>
                    <v-btn @click="showCard=!showCard" v-if="!showCard" dark fab small color="blue"><h2> + </h2></v-btn>
                </v-flex>
            </v-toolbar>
            <v-card-text class="body-2" v-if="showCard">
            <div class="body-2">
                <h3 display-1 :style="$store.state.textFormatting.main" class="text-xs-center">
                    Welcome to the BGP Spotlight web application.
                </h3>
                <br/><hr/><br/>
                <h4 :style="$store.state.textFormatting.main">
                    This tool introduces a Hijack (H) and Impact (I) scores to BGP EVENTS to aid the comparison of BGP activity, these range from 0 to 100. A collection of related Events are grouped into an EPISODE which will take the average ‘H’ and ‘I’ scores from its component EVENTS.
                    <br /><br />
                    The Hijack score reflects how malicious the EPISODE is deemed to be, with 99 being the highest BGP Spotlight will rate an EPISODE.
                    <br /><br />
                    The Impact score reflects the effect such a change may have if it is indeed malicious. For example, the tool has some predefined network ranges for root DNS servers and will set the Impact score to 99 for EPISODES that affect those. Users can set their own Impact scores for monitored <v-btn small @click="routeNewWindow('Restricted Prefix Settings')" color="success" :style="$store.state.textFormatting.main">network ranges</v-btn>.
                    <br /><br />
                    Users must predefine <v-btn small @click="routeNewWindow('Restricted Prefix Settings')" color="success" :style="$store.state.textFormatting.main">network ranges</v-btn> and/or <v-btn small @click="routeNewWindow('ASN Settings')" color="success" :style="$store.state.textFormatting.main">ASNs</v-btn> to monitor. EPISODES raised as an ALERT will be shown on the <v-btn small @click="routeNewWindow('Organisation Alerts')" color="success" :style="$store.state.textFormatting.main">organisation alerts</v-btn> / <v-btn small @click="routeNewWindow('User Alerts')" color="success" :style="$store.state.textFormatting.main">user alerts</v-btn> page for 60 days.
                    <br /><br />
                    EPISODES that affect a predefined ASN will be shown as an ALERT if the 'H' and/or 'I' score exceeds a threshold, as defined under 'Edit ASNS' tab, for that ASN.
                    <br /><br />
                    EPISODES that affect Restricted prefixes will always be shown as an ALERT and will have a minimum Impact score as defined under 'Edit Restricted Prefixes' page, for that prefix.
                    <br /><br />
                    There are two sets of ASNs/ Prefixes a user may observe, those for their 'Organisation' and those for their own 'User' analysis.
                    <br /><br />
                    Only Admins may edit the details for an organisation and the same ASNs, Restricted prefixes, thresholds, and ALERTS are shown FOR ALL USERS where their accounts are grouped within the same organisation.
                    <br /><br />
                    A 'User's' ASNs, Restricted prefixes, thresholds, and ALERTS are unique to a user's account and are private and unique to that user.
                </h4>
            </div>       
            </v-card-text>
        </v-card>
    </div>
</template>

<script>
export default {
    name: 'gettingstarted',
    data() {
        return {
            showCard: true
        }
    },
    beforeMount () {
        this.showCard = this.$store.state.showSettings.gettingStarted
    },
    methods: {
        routeNewWindow: async function (input) {
            let routeData = this.$router.resolve({name: input});
            window.open(routeData.href, '_blank');
        }
    },
    watch: {
        showCard(n) {
            this.$store.commit("setShowSettings", {'gettingStarted': n})
        }
    }
}
</script>


























